import React from "react";

import { HollowButton } from "./Button";
import { sendEvent } from "src/hooks/analytics";

const REDIRECT_HELP_CENTER_URL =
  "https://ajuda.globo.com/s/article/Associei-uma-operadora-ao-Globoplay-o-que-posso-assistir";

export interface GloboHelpButtonProps {
  pageNameCustom: string;
  providerName: string;
  globoId: string;
}

export function GloboHelpButton({
  pageNameCustom,
  providerName,
  globoId
}: GloboHelpButtonProps) {
  const redirectToHelpCenter = () => {
    sendEvent(
      "component_click",
      {
        component_name: "ir_para_ajuda_globo",
        component_type: "button",
        component_item_link_redirect: REDIRECT_HELP_CENTER_URL,
        page_name_custom: pageNameCustom,
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    window.open(REDIRECT_HELP_CENTER_URL, "_blank");
  };

  return (
    <HollowButton onClick={redirectToHelpCenter}>
      Ir para a Ajuda Globo
    </HollowButton>
  );
}
